<mat-card-title class="custom-card-title text-align-center">
  {{ data.titleKey | translate }}
  <button aria-label="Close" type="button" class="dialog-close-btn" mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</mat-card-title>

@if (data.subtitle) {
  <div class="history-subtitle">{{ data.subtitle }}</div>
}

<mat-dialog-content class="history-content">
  @if (data.rows.length === 0) {
    <div class="history-empty">{{ 'COMMON.HISTORY_EMPTY' | translate }}</div>
  } @else {
    <ol class="history-timeline">
      @for (row of data.rows; track row.id) {
        <li class="history-row" [class.history-row-admin]="row.adminOverride">
          <div class="history-marker">
            <mat-icon>{{ icon(row.eventType) }}</mat-icon>
          </div>

          <div class="history-body">
            <div class="history-headline">
              @if (row.eventType === 'CREATED') {
                <span class="history-event">{{ 'COMMON.HISTORY_CREATED' | translate }}</span>
              } @else if (row.eventType === 'STATUS_CHANGE') {
                <span class="history-event">
                  @if (row.fromStatus) {
                    <span class="history-status">{{ statusKey(row, row.fromStatus) | translate }}</span>
                    <mat-icon class="history-arrow">arrow_right_alt</mat-icon>
                  }
                  <span class="history-status">{{ statusKey(row, row.toStatus) | translate }}</span>
                </span>
              } @else if (row.eventType === 'EDIT') {
                <span class="history-event">{{ 'COMMON.HISTORY_EDITED' | translate }}</span>
              } @else {
                <span class="history-event">{{ 'COMMON.HISTORY_NOTE_ADDED' | translate }}</span>
              }

              @if (row.adminOverride) {
                <span class="history-admin-chip" matTooltip="{{ 'COMMON.HISTORY_ADMIN_OVERRIDE_HINT' | translate }}">
                  {{ 'COMMON.HISTORY_ADMIN_OVERRIDE' | translate }}
                </span>
              }
            </div>

            <div class="history-meta">
              @if (row.actorName) {
                <span class="history-actor">{{ row.actorName }}</span>
                @if (row.actorRole) {
                  <span class="history-role">{{ 'COMMON.HISTORY_ROLE_' + row.actorRole | translate }}</span>
                }
              } @else {
                <span class="history-actor-unknown">{{ 'COMMON.HISTORY_ACTOR_UNKNOWN' | translate }}</span>
              }
              <span class="history-date">{{ row.createdDate | date: 'medium' }}</span>
            </div>

            @if (row.details?.length) {
              <ul class="history-details">
                @for (detail of row.details; track detail.labelKey) {
                  <li>
                    <span class="history-detail-label">{{ detail.labelKey | translate }}</span>
                    <span class="history-detail-from">{{ detail.from || ('COMMON.HISTORY_EMPTY_VALUE' | translate) }}</span>
                    <mat-icon class="history-arrow">arrow_right_alt</mat-icon>
                    <span class="history-detail-to">{{ detail.to || ('COMMON.HISTORY_EMPTY_VALUE' | translate) }}</span>
                  </li>
                }
              </ul>
            }

            @if (row.noteKey) {
              <div class="history-note history-note-system">{{ row.noteKey | translate }}</div>
            } @else if (row.note) {
              <div class="history-note">{{ row.note }}</div>
            }
          </div>
        </li>
      }
    </ol>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" (click)="close()" mat-stroked-button>{{ 'COMMON.CLOSE' | translate }}</button>
</mat-dialog-actions>
